module.exports = {"330723001":"白洋街道","330723002":"壶山街道","330723003":"熟溪街道","330723100":"柳城畲族镇","330723101":"履坦镇","330723102":"桐琴镇","330723103":"泉溪镇","330723104":"新宅镇","330723105":"王宅镇","330723106":"桃溪镇","330723107":"茭道镇","330723200":"大田乡","330723201":"白姆乡","330723202":"俞源乡","330723203":"坦洪乡","330723204":"西联乡","330723205":"三港乡","330723206":"大溪口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330723.json
// module id = 920
// module chunks = 0